// extracted by mini-css-extract-plugin
export var noSpinners = "_si-6";
export var percentageInput = "_si-7";
export var variantColor1 = "_si-0";
export var variantColor2 = "_si-1";
export var variantColor3 = "_si-2";
export var variantColor4 = "_si-3";
export var variantColor5 = "_si-4";
export var variantColor6 = "_si-5";